import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/expediaActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportRatesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchExpediaRates = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.EXPEDIA_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.expediaRatesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_fetchRatesSuccess(getParser(urls.expediaRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.expedia_fetchRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const postExpediaRate = payload => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }
    const { auth } = getState()

    securedFetch(urls.expediaRates, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_saveRatesSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.expedia_saveRatesFailure,
                'Что-то пошло не так!',
                'При сохранении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteExpediaRate = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.expediaRateSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_deleteRateSuccess(remoteId)))
        .then(() => toastr.success('Тариф удален'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_deleteRateFailure,
                'Что-то пошло не так!',
                'При удалении тфрифа произошла ошибка'
            )
        )
}

/** @thunk **/
export const importExpediaRates = () => (dispatch, getState) => {
    const { expediaCurrentOrganization } = getState()
    const { auth } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: expediaCurrentOrganization })
    }

    securedFetch(urls.reloadRatesFromExpedia, auth, opts)
        .then(handleResponse)
        .then(showImportRatesToastr)
        .then(json => dispatch(actions.expedia_importRatesSuccess(getParser(urls.reloadRatesFromExpedia)(json))))
        .catch(
            handleError(
                dispatch,
                actions.expedia_importRatesFailure,
                'Что-то пошло не так!',
                'При импорте тарифов произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/expediaApi/expediaRates.js